import React from "react";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/PageHeader";

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <Seo title="Terms of Service" description="Terms of Service for Cody Wallace Enterprises (Iridescent Medical & Wellness Spa), including SMS/text messaging terms." path="/terms" />
      <PageHeader title="Terms of Service" subtitle="Cody Wallace Enterprises · Iridescent Medical & Wellness Spa" />
      <div className="max-w-3xl mx-auto px-6 pb-24 prose prose-slate text-[#5C6664] leading-relaxed space-y-6">
        <p className="text-sm">Last updated: {new Date().getFullYear()}</p>

        <section>
          <h2 className="font-heading text-2xl text-ink">Text Messaging (SMS) Terms</h2>
          <p>By providing your mobile number and checking the consent box, you agree to receive automated marketing and account-related text messages from Cody Wallace Enterprises (operating as Iridescent Medical &amp; Wellness Spa) at the number provided. Consent is not a condition of any purchase.</p>
          <ul className="list-disc pl-6 space-y-1">
            <li><strong>Message frequency:</strong> up to 4 messages per month.</li>
            <li><strong>Rates:</strong> message and data rates may apply based on your carrier plan.</li>
            <li><strong>Opt out:</strong> reply STOP at any time to unsubscribe. Reply HELP for assistance.</li>
            <li>Carriers are not liable for delayed or undelivered messages.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-ink">Use of Services</h2>
          <p>All content, treatments, and offers are provided by Cody Wallace Enterprises. Pricing, promotions, and availability may change without notice. Medical and aesthetic services are subject to consultation and provider approval.</p>
        </section>

        <section>
          <h2 className="font-heading text-2xl text-ink">Contact</h2>
          <p>Questions about these terms? Call (586) 690-8693 or visit us at 42855 Garfield Rd, Suite 105, Clinton Township, MI 48038.</p>
        </section>
      </div>
    </div>
  );
}
